import { render, staticRenderFns } from "./TerminComponent.vue?vue&type=template&id=09f12e06&v-if=wolnytermin&"
import script from "./TerminComponent.vue?vue&type=script&lang=js&"
export * from "./TerminComponent.vue?vue&type=script&lang=js&"
import style0 from "./TerminComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports